import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { cn } from '@shared/lib';
import { useToggle } from '@shared/lib/hooks';
import { SideNav } from './SideNav';
import { UserRole } from '@entities/auth';
import { getNavItemsForRole } from '../constants/nav-items';

type SidebarProps = {
  className?: string;
  id?: string;
  role: UserRole;
  memberStatus: 'active' | 'inactive' | undefined;
  stripe_link?: string;
};

export const Sidebar = ({
  className,
  id,
  role,
  memberStatus,
  stripe_link,
}: SidebarProps) => {
  const { toggle: isOpen, toggleStatus } = useToggle();
  const [status, setStatus] = useState(false);
  const { pathname } = useLocation();
  const NAV_ITEMS = getNavItemsForRole(role, stripe_link, memberStatus);
  const handleToggle = () => {
    setStatus(true);
    toggleStatus();
    setTimeout(() => setStatus(false), 500);
  };

  return (
    <div
      id={id}
      className={cn(
        `relative hidden h-screen pt-10 md:block`,
        status && 'duration-500',
        isOpen ? 'w-60' : 'w-[80px]',
        //Scheduler cannot have a sidebar
        pathname === '/scheduler' && 'h-0 md:hidden',
        className
      )}
    >
      <ArrowLeft
        className={cn(
          'absolute -right-4 top-[104px] cursor-pointer rounded-full border bg-background text-3xl text-foreground',
          !isOpen && 'rotate-180'
        )}
        onClick={handleToggle}
      />
      <div className="space-y-4 py-2">
        <div className="px-3 py-2">
          <div className="mt-3 space-y-1">
            <SideNav
              className="duration-250 -z-10 text-background opacity-0 transition-all group-hover:z-10 group-hover:ml-4 group-hover:rounded group-hover:bg-foreground group-hover:p-2 group-hover:opacity-100"
              items={NAV_ITEMS}
              isOpen={isOpen}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
